import useAvailableBalance from './useAvailableBalance'
import useLockedBalance from './useLockedBalance'

const useTotalBalance = () => {
  const lockedBalance = useLockedBalance()
  const availableBalance = useAvailableBalance()

  return {
    goldBalanceInUsd: lockedBalance.goldBalanceInUsd.plus(
      availableBalance.goldBalanceInUsd
    ),
    rwaBalanceInUsd: lockedBalance.rwaBalanceInUsd.plus(
      availableBalance.rwaBalanceInUsd
    ),
    cryptoBalanceInUsd: lockedBalance.cryptoBalanceInUsd.plus(
      availableBalance.cryptoBalanceInUsd
    ),
    carbonBalanceInUsd: lockedBalance.cryptoBalanceInUsd.plus(
      availableBalance.carbonBalanceInUsd
    ),
    totalBalanceInUsd: lockedBalance.totalBalanceInUsd.plus(
      availableBalance.totalBalanceInUsd
    ),
    loading: lockedBalance.loading || availableBalance.loading,
  }
}

export default useTotalBalance
